export enum OperationalPriceListAccountFactorType {
  LUMP_SUM = 'lump_sum',
  PERCENT = 'percent'
}
